<template>
	<div class="flex flex-col gap-4">
		<Accordion label="Intensidade amostral">
			<div class="flex flex-col gap-2">
				<div class="border border-[#737576] rounded p-2 flex flex-col gap-2">
					<ToggleSwitch
						v-model="ordemServico.orsv_is_cv"
						label="Calcular por Coeficiente de Variação"
					/>
					<Input
						v-if="ordemServico.orsv_is_cv"
						v-model="ordemServico.orsv_nr_amostra_referencia"
						label="número de parcelas de referência"
						placeholder="Digite aqui"
						type="number"
					/>
					<Input
						v-if="ordemServico.orsv_is_cv"
						v-model="ordemServico.orsv_nr_cv"
						label="coeficiente de variação (%)"
						placeholder="Digite aqui"
						type="number"
					/>
					<Input
						v-if="ordemServico.orsv_is_cv"
						v-model="ordemServico.orsv_nr_error_target"
						placeholder="Digite aqui"
						label="target de erro (%)"
						type="number"
					/>
				</div>
				<Input
					v-model="hectaresPorParcela"
					label="hectares por parcela"
					placeholder="Digite aqui"
					type="number"
				/>
				<Input
					v-model="totalDeParcelas"
					label="total de parcelas"
					placeholder="Digite aqui"
					type="number"
				/>
			</div>
		</Accordion>

		<Accordion label="Metodologia amostral">
			<Dropdown
				v-model="ordemServico.orsv_tx_metodologia_amostral"
				label="Metodologia amostral"
				:options="metodologiasAmostrais"
			/>
		</Accordion>

		<Accordion label="Campos opcionais">
			<div class="flex flex-col gap-2">
				<Input
					v-model.number="ordemServico.orsv_nr_buffer"
					placeholder="Digite aqui"
					label="buffer de talhão (m)"
					type="number"
				/>
				<Input
					label="buffer de parcela (m)"
					type="number"
					placeholder="Digite aqui"
				/>
			</div>
		</Accordion>

		<div class="flex justify-between gap-4">
			<Button
				secondary
				class="!border-none w-1/2 justify-center"
				text="limpar filtros"
				@click="$emit('limpar')"
			/>
			<Button
				text="lançar parcelas"
				class="w-1/2 justify-center"
				@click="$emit('lancar')"
			/>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue'
import Accordion from '../../../components/ui/accordion/Accordion.vue'
import Button from '../../../components/ui/button/Button.vue'
import Dropdown from '../../../components/ui/dropdown/Dropdown.vue'
import Input from '../../../components/ui/input/Input.vue'
import ToggleSwitch from '../../../components/ui/switch/ToggleSwitch.vue'
import { usePlanejamentoOrdemServico } from '../../../composables/usePlanejamentoOrdemServico'

const { ordemServico, hectaresPorParcela, totalDeParcelas } = usePlanejamentoOrdemServico()

const metodologiasAmostrais = ref([
	{
		label: 'Sistemática',
		value: 'Sistematica',
	},
	{
		label: 'Aleatória',
		value: 'Aleatoria',
	},
	{
		label: 'Aleatória em dois estágios',
		value: 'AleatoriaDoisEstagios',
	},
])
</script>

<style></style>
